mutation SupplierUrgentUpdate($input: SupplierUrgentUpdateInput!) {
  supplierUrgentUpdate(input: $input) {
    clientMutationId
         _newUrgentLevel
  }
}
